module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em",
      "margin-bottom": "12em"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [(_vm.menu_tab_inner_view['general_goods_category_products']) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "16em"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "margin-right": "0.8em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  })])]), _vm._v(_vm._s(_vm.general_goods_category.category_name) + "\r\n            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "2.2em",
      "color": "#5703a5"
    }
  }, [_vm._v("select products")])]), _vm._v(" "), _vm._l((_vm.general_goods_category_products), function(set_product, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "col-xs-1"
    }, [_c('input', {
      staticStyle: {
        "height": "3em"
      },
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddItemsToList(set_product, index)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticClass: "card-avatar-square"
    }, [(set_product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": set_product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(set_product.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("₦‎" + _vm._s(set_product.product_items[0].product_item_price_f))])]), _vm._v(" "), (_vm.checkItemInList(set_product)) ? _c('div', [_c('b', [_vm._v("Price: ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (set_product.product_items[0].product_item_price),
        expression: "set_product.product_items[0].product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (set_product.product_items[0].product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          set_product.product_items[0].product_item_price = $event.target.value
        }
      }
    }), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quantity / Stock: ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (set_product.product_item_quantity),
        expression: "set_product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (set_product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          set_product.product_item_quantity = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e()])])])
  })], 2) : (_vm.menu_tab_inner_view['custom_add']) ? _c('div', {
    staticClass: "card"
  }, [_vm._v("\r\n          Custom Add New\r\n        ")]) : _c('div', [(_vm.business_type == 2) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "card card-box",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('h4', {
    staticClass: "card-head"
  }, [_vm._v("Shop Specific Categories\r\n                  "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'view_categories'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777777",
      "line-height": "1.8"
    }
  }, [_vm._v("Add  your personal shop categories specific to\r\n                  your shop alone.\r\n                ")])]), _vm._v(" "), (_vm.set_view == 'view_custom') ? _c('div', [_c('hr'), _vm._v("\r\n                Add Category\r\n              ")]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.set_view == 'view_general') ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "card card-box",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('h4', {
    staticClass: "card-head"
  }, [_vm._v("General Goods Store Categories\r\n                  "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'view_general'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777777",
      "line-height": "1.8"
    }
  }, [_vm._v("Add general goods categories by selecting products in that categories, This is \r\n                  specifically for shops that sells retail, wholesale general goods\r\n                ")])]), _vm._v(" "), (_vm.set_view == 'view_general') ? _c('div', {
    staticClass: "card card-box",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('h4', {
    staticClass: "card-head",
    staticStyle: {
      "font-weight": "lighter"
    }
  }, [_vm._v("Select from these categories")]), _vm._v(" "), ((Object.keys(_vm.general_goods).length > 0)) ? _c('div', {
    key: _vm.componentKey
  }, _vm._l((_vm.general_goods), function(category, index) {
    return _c('div', {
      staticClass: "card card-box-fl"
    }, [_c('h5', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setGeneralGoodsCategoryProducts(category)
        }
      }
    }, [_vm._v("\r\n                        " + _vm._s(category.category_name) + "\r\n                        "), _vm._m(1, true)])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), (_vm.menu_tab_inner_view['general_goods_category_products']) ? _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "4.6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', [_vm._v("Total Items selected")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.set_items_list.length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.prepSetAddProductsInList()
      }
    }
  }, [_vm._v("\r\n          Add Category")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4dccd6"}!./src/pages/Manage/AddCategories/template.html
// module id = 571
// module chunks = 0